import React from 'react';
import { faQuestionCircle } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { BoldSmallBodyText, Header5Text, SmallBodyText, SpacerRow, Tooltip } from 'ui-toolkit';
import { useHasFeatureFlag } from 'selectors/useHasFeatureFlag';

export interface IExpectedLenderMoneyLabelProps {}

export const ExpectedLenderMoneyLabel: React.FC<IExpectedLenderMoneyLabelProps> = () => {
  const isZillowClosingEnabled = useHasFeatureFlag('pinecone.zillow-closing');
  const sendingToText = isZillowClosingEnabled ? 'Zillow Closing' : 'Spruce';

  return (
    <Tooltip
      placement={'bottom'}
      tooltipContent={
        <>
          <BoldSmallBodyText>What is this?</BoldSmallBodyText>
          <SmallBodyText>
            This represents value of the funds that Spruce expects from the Lender to fund this order.
          </SmallBodyText>
          <SpacerRow />
          <BoldSmallBodyText>How is it calculated?</BoldSmallBodyText>
          <SmallBodyText>
            Loan amount
            <br />
            - Netted Out Borrower-Paid Bank Fees
            <br />
            + Lender Credits
            <br />+ Lender Paid: Sending to {sendingToText}
            <br />= Expected Lender Money
          </SmallBodyText>
          <SpacerRow />
        </>
      }
    >
      <div className={'flex flex-row items-center gap-1'}>
        <Header5Text>Lender</Header5Text>
        <FontAwesomeIcon icon={faQuestionCircle} />
      </div>
    </Tooltip>
  );
};
